export const kioskUsername = '';
